var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M13 5.5H3C2.72386 5.5 2.5 5.72386 2.5 6V13C2.5 13.2761 2.72386 13.5 3 13.5H13C13.2761 13.5 13.5 13.2761 13.5 13V6C13.5 5.72386 13.2761 5.5 13 5.5Z",
    fill: "#6C7689"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.125 6.125V12.875H12.875V6.125H3.125ZM1.875 6C1.875 5.37868 2.37868 4.875 3 4.875H13C13.6213 4.875 14.125 5.37868 14.125 6V13C14.125 13.6213 13.6213 14.125 13 14.125H3C2.37868 14.125 1.875 13.6213 1.875 13V6Z",
    fill: "#6C7689"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.625C7.56902 1.625 7.1557 1.7962 6.85095 2.10095C6.5462 2.4057 6.375 2.81902 6.375 3.25V5.5C6.375 5.84518 6.09518 6.125 5.75 6.125C5.40482 6.125 5.125 5.84518 5.125 5.5V3.25C5.125 2.4875 5.4279 1.75623 5.96707 1.21707C6.50624 0.677901 7.2375 0.375 8 0.375C8.7625 0.375 9.49376 0.677901 10.0329 1.21707C10.5721 1.75623 10.875 2.4875 10.875 3.25V5.5C10.875 5.84518 10.5952 6.125 10.25 6.125C9.90482 6.125 9.625 5.84518 9.625 5.5V3.25C9.625 2.81902 9.45379 2.4057 9.14905 2.10095C8.8443 1.7962 8.43098 1.625 8 1.625Z",
    fill: "#6C7689"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.25C8.41421 10.25 8.75 9.91421 8.75 9.5C8.75 9.08579 8.41421 8.75 8 8.75C7.58579 8.75 7.25 9.08579 7.25 9.5C7.25 9.91421 7.58579 10.25 8 10.25Z",
    fill: "#6C7689"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.6d5547e3941aae5a655abb0d7c7cbc71.svg";
export { ForwardRef as ReactComponent };